import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function useQueryParams<T extends string>() {
  const [searchParams, setSearchParams] = useSearchParams();

  const setParams = useCallback(
    (list: { key: T; value: string }[]) => {
      setSearchParams((prev) => {
        list.forEach(({ key, value }) => {
          if (!value) {
            prev.delete(key);
          } else {
            prev.set(key, value);
          }
        });
        return prev;
      });
    },
    [setSearchParams],
  );

  const setEntry = useCallback(
    (key: T, value: string) => {
      setSearchParams((prev) => {
        prev.set(key, value);
        return prev;
      });
    },
    [setSearchParams],
  );

  return { searchParams, setParams, setEntry };
}
